import React from 'react'

function LeftThreeDot(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36.617" height="57.738" viewBox="0 0 36.617 57.738" {...props}>
      <g data-name="Group 51998" transform="rotate(-174 19.99 22.78)">
        <circle
          cx="5.685"
          cy="5.685"
          r="5.685"
          fill="#fe5f55"
          data-name="Ellipse 1015"
          transform="translate(.983 -10.373)"
        ></circle>
        <circle
          cx="4.422"
          cy="4.422"
          r="4.422"
          fill="#d3dade"
          data-name="Ellipse 1026"
          transform="translate(29.746 8.497)"
        ></circle>
        <circle
          cx="2.527"
          cy="2.527"
          r="2.527"
          fill="#fe5f55"
          data-name="Ellipse 1025"
          transform="translate(12.684 40.87)"
        ></circle>
      </g>
    </svg>
  )
}

export default LeftThreeDot
